// extracted by mini-css-extract-plugin
export default {"tab-base":"tab-base_tab-base__KQAsv","tab-base__tab-name":"tab-base_tab-base__tab-name__lSxXr","badge":"tab-base_badge__WVTQX"};